document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('[data-row="claim_number"] td').forEach(cell => {
        cell.innerHTML = createElement("span", {
            innerHTML: cell.innerHTML,
            style: "white-space: nowrap;",
            dir: "ltr"
        }).outerHTML
    })
})
